export default function downloadCsvData(csvData, filename) {
    console.debug("downloadCsvData: ", csvData, filename);
    // Convert csvData to CSV string
    let csvContent = "";

    for (let row of csvData) {
        // console.debug("row: ", row);
        // Convert each row to a comma-separated string
        const rowString = row.map(item => {
            // Escape double quotes by replacing them with two double quotes
            const escapedItem = item.toString().replace(/"/g, '""');
            // Wrap the item in double quotes
            return `"${escapedItem}"`;
        }).join(",");
        // Append the row string to the CSV content
        csvContent += rowString + "\n";
    }

    console.debug("csvContent: ", csvContent);
    // Create a Blob from the CSV string
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    // Create a link element
    const link = document.createElement("a");
    // Create a URL for the Blob    
    const url = URL.createObjectURL(blob);
    // Set the link's href to the Blob URL
    link.setAttribute("href", url);
    // Set the download attribute with the filename
    link.setAttribute("download", filename);
    // Append the link to the body
    document.body.appendChild(link);
    // Programmatically click the link to trigger the download
    link.click();
    // Clean up by removing the link and revoking the Blob URL

    document.body.removeChild(link);
    URL.revokeObjectURL(url);
    console.debug("CSV file downloaded: ", filename);
}
